export default __webpack_public_path__ + "static/services-details1b-f8af23afe13d30984f904396304eb500.jpg";